"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var sanity_query_1 = require("@aonawale/sanity-query");
var use_query_1 = require("../use-query");
/**
 * A hook that fetches a document from Sanity.
 * @param client - The Sanity client.
 * @param query - The query to fetch a document with.
 * @param projection - The projection to fetch a document with.
 * @returns The query response.
 * @example
 * const client = sanityClient({...})
 * const query = {
 *  id: '123',
 * }
 * const projection = '_id, name, age'
 * const {data, error, isLoading} = useGetDocument(client, query, projection)
 * console.log(data, error, isLoading)
 * => {_id: '...', name: 'John', age: 42}, undefined, false
 */
var useGetDocument = function (client, query, projection) {
    var documentQuery = query
        ? {
            constraints: __spreadArray(__spreadArray([
                (0, sanity_query_1.filter)('_id', '==', query.id)
            ], (query.type ? [(0, sanity_query_1.filter)('_type', '==', query.type)] : []), true), [
                (0, sanity_query_1.slice)(0),
            ], false),
        }
        : undefined;
    return (0, use_query_1.useQuery)(client, documentQuery, documentQuery ? projection : undefined);
};
exports.default = useGetDocument;
//# sourceMappingURL=use-get-document.js.map